import { render } from "./BookAppointmentPopup.vue?vue&type=template&id=3edd77de&scoped=true"
import script from "./BookAppointmentPopup.vue?vue&type=script&lang=js"
export * from "./BookAppointmentPopup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3edd77de"

export default script